let cachedAssetBase: string | undefined;

function normalizeBase(value: string): string {
  return value.replace(/\/+$/, "");
}

export function getAculAssetBase(): string {
  if (cachedAssetBase !== undefined) {
    return cachedAssetBase;
  }

  if (typeof window === "undefined" || typeof document === "undefined") {
    cachedAssetBase = "";
    return cachedAssetBase;
  }

  const explicitBase = (window as Window & { __ACUL_ASSET_BASE?: string })
    .__ACUL_ASSET_BASE;
  if (typeof explicitBase === "string" && explicitBase.trim().length > 0) {
    cachedAssetBase = normalizeBase(explicitBase.trim());
    return cachedAssetBase;
  }

  const scripts = Array.from(document.querySelectorAll("script[src]"));
  const mainScript = scripts.find((script) => {
    const src = script.getAttribute("src") || "";
    return /\/assets\/main\.[^/]+\.js$/.test(src);
  }) as HTMLScriptElement | undefined;

  if (mainScript?.src) {
    const parsed = new URL(mainScript.src, window.location.href);
    cachedAssetBase = `${parsed.protocol}//${parsed.host}`;
    return cachedAssetBase;
  }

  cachedAssetBase = "";
  return cachedAssetBase;
}

export function resolveAculAssetUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const base = getAculAssetBase();
  return `${base}${normalizedPath}`;
}

